// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".float-right[data-v-4200bc29]{float:right}.nvic_search[data-v-4200bc29]{background-color:rgba(33,150,243,.25098039215686274)!important}", ""]);
// Exports
module.exports = exports;
